<template>
  <div class="employee-modal">
    <div class="employee-modal__image">
      <Image :source="$store.state.app.employee.image"/>
      <VideoLink v-if="$store.state.app.employee.video?.length" :content="$store.state.app.employee.video[0]" large
                 class="employee-modal__video"/>
    </div>
    <RawHtml :html="$store.state.app.employee.description" class="employee-modal__content"/>
  </div>
</template>

<script>
import {Image, RawHtml} from '@/components/global'
import VideoLink from '@/components/small/VideoLink.vue'

export default {
  name: 'EmployeeModal',
  components: {VideoLink, Image, RawHtml}
}
</script>